export const accessToken = {
    get: {
        tokenType() {
            const token_type = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token'))['token_type'] : null;
            return token_type;
        },
        accessToken() {
            const access_token = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token'))['access_token'] : null;
            return access_token;
        },
        refreshToken() {
            const refresh_token = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token'))['refresh_token'] : null;
            return refresh_token;
        }
    },
    set(access_token) {
        localStorage.setItem('access_token', access_token);
    },
    delete() {
        localStorage.removeItem('access_token');
    }
};